/**
 * Sticky Div class
 */
import I96ScrollChecker from "../i96-scroll_checker.class.js";

/**
 * Possible Sticky status: STUCK_TOP, UNSTUCK, STUCK_BOTTOM
 */
class I96StickyStatus {
    // Private Fields
    static #_STUCK_TOP = '_sticky-stuck-top';
    static #_UNSTUCK = '_sticky-unstuck';
    static #_STUCK_BOTTOM = '_sticky-stuck-bottom';

    // Accessors for "get" functions only (no "set" functions)
    static get STUCK_TOP() { return this.#_STUCK_TOP; }
    static get UNSTUCK() { return this.#_UNSTUCK; }
    static get STUCK_BOTTOM() { return this.#_STUCK_BOTTOM; }
}

class I96StickyStuff extends I96ScrollChecker {

    constructor(config = {}) {
        super( config );

        this.debug = false;

        const settings_stickystuff_default = {
            offset: 200,
            selector_sections: '.section-text-block-mit-sidebar.-desktop',
            selector_stuff: '.i96-stickystuff-stuff',
            selector_wrapper: '.i96-stickystuff-wrapper',
            stuffs: [],
            sections: [],
            iz_resizing: false
        }

        this.settings = {
            ...settings_stickystuff_default,
            ...config
        }

        if (this.debug) console.log('I96StickyStuff: constructor('+config+')');

        this.init();

    }

    init() {
        if (this.debug) console.log('I96StickyStuff: init()');

        this.settings.stuffs = document.querySelectorAll( this.settings.selector_stuff );
        this.settings.sections = document.querySelectorAll( this.settings.selector_sections );
        this.settings.haz_multiple_sections = this.settings.sections && this.settings.sections.length > 1;

        // initializes the parent classe's scroll event
        if (this.settings.stuffs.length) {
            this._setupScroll(this._onScroll.bind(this));
            console.log(this.settings.stuffs);
        }

        // init resizer
        window.addEventListener(
            'resize',
            this._onResize.bind(this)
        );

    }

    _onResize() {
        if (this.debug) console.log('I96StickyStuff: _onResize()', this.scroll_data);

        this.settings.iz_resizing = true;

        this._onScroll( true )
        // cehck for stuck to bottom situation and update that as well
        // fix width of sidebar
    }

    _stickIt( ele, force_it = false ) {

        if (ele.style.position !== 'fixed' || force_it) {

            if (this.debug) console.log('I96StickyStuff: _stickIt()', ele, force_it);

            const parent_pos = ele.parentElement.getBoundingClientRect();
            const offset = parseInt( ele.getAttribute('data-stickystuff-offset') );
            ele.style.position = 'fixed';
            ele.style.top = offset + 'px';
            ele.style.left = parent_pos.x + 'px';
            ele.style.bottom = 'auto';
            ele.style.width = (parent_pos.right - parent_pos.left - parseInt( getComputedStyle(ele).marginLeft) ) + 'px';
            ele.classList.add( I96StickyStatus.STUCK_TOP );
            ele.classList.remove( I96StickyStatus.UNSTUCK );
            ele.classList.remove( I96StickyStatus.STUCK_BOTTOM );
        }

    }

    _unStickIt( ele, last_el_pos = null, force_it = false ) {
        if (this.debug) console.log('I96StickyStuff: _unStickIt()');

        // const offset = parseInt( ele.getAttribute('data-stickystuff-offset') );
        // const parent_pos = ele.parentElement.getBoundingClientRect();

        // stick to bottom of wrapper
        if (last_el_pos !== null) {

            if (ele.style.position !== 'absolute' || force_it) {

                if (this.debug) console.log('I96StickyStuff: _unStickIt() > last_el_pos !== null', last_el_pos);

                let bottom = '0';
                if ( this.settings.haz_multiple_sections ) {
                    bottom = '-'+last_el_pos.height+'px';
                }
                ele.style.position = 'absolute';
                ele.style.top = 'auto';
                ele.style.left = '0';
                ele.style.bottom = bottom;
                ele.style.width = 'auto';
                ele.classList.add( I96StickyStatus.STUCK_BOTTOM );
                ele.classList.remove( I96StickyStatus.UNSTUCK );
                ele.classList.remove( I96StickyStatus.STUCK_TOP );
            }
        // reset to default > stick to top of wrapper
        } else {
            if (ele.style.position !== 'absolute' || force_it) {

                if (this.debug) console.log('I96StickyStuff: _unStickIt() > last_el_pos === null');

                ele.style.position = 'absolute';
                ele.style.top = '0';
                ele.style.left = '0';
                ele.style.width = 'auto';
                ele.classList.add( I96StickyStatus.STUCK_TOP );
                ele.classList.remove( I96StickyStatus.STUCK_BOTTOM );
                ele.classList.remove( I96StickyStatus.UNSTUCK );
            }
        }

    }

    /**
     * Get next element that is the last text-block-with-sidebar element and stop there
     *
     * @param stuff
     * @returns {*}
     * @private
     */
    _getStickyElement( stuff ) {
        let ele = stuff.closest('.section-text-block-mit-sidebar');

        // Get next element that is the last text-block-with-sidebar element and stop there
        if ( this.settings.haz_multiple_sections ) {

            while (ele && ele.nextElementSibling && ele.nextElementSibling.classList.contains('section-text-block-mit-sidebar')) {
                ele = ele.nextElementSibling;
            }

        // only one element there
        } else {
            // i don't know what i am doing, just a workaround because of the changes necessary for the late req by the client that it should scroll to the bottom...

            if (ele.classList.contains('-mobile')) {
                ele = ele.previousElementSibling;
            }

        }

        return ele;
    }

    // todo: reposition sticky on resize!

    _onScroll( force_init = false) {

        // if (this.debug) console.log('I96StickyStuff: _onScroll()', this.scroll_data);

        this.settings.stuffs.forEach( stuff => {
            const offset = parseInt( stuff.getAttribute('data-stickystuff-offset') );
            const parent_pos = stuff.parentElement.getBoundingClientRect();

            // console.log(offset, parent_pos, stuff.parentElement);

            // wrapper reached top
            if (parent_pos.y < offset) {

                let sticky_ele = this._getStickyElement( stuff );

                const sticky_ele_pos = sticky_ele.querySelector('.lewo-sec-content').getBoundingClientRect();

                // wrapper too far gone, stick to bottom of wrapper
                if ( (sticky_ele_pos.height + sticky_ele_pos.y - sticky_ele.style.paddingBottom - offset) < stuff.getBoundingClientRect().height ) {
                    this._unStickIt( stuff, sticky_ele.getBoundingClientRect(), force_init );

                // fix to window top
                } else {
                    this._stickIt( stuff, force_init );
                }
            // wrapper not at top yet
            } else {
                this._unStickIt( stuff, null, force_init );
            }
        });

    }

}

export default I96StickyStuff